<template>
  <div>
    <notifications />    
    <div id="main">
        <div class="content">
            <div class="grid-container">
                <div class="center" id="header">
                    <div class="title-main">Sign with qualified eSignatures and manage documents online</div>
                    <div class="text-big">Reliable, compliant and cost effective signatures for your documents.</div>
                </div>
                <div class="center" id="trusted">
                    <div class="title-small">Trusted by</div>
                    <div class="trusted">
                        <img style="width: 112px; height: 24px" src="@/assets/icons/ms.png" />
                        <img style="width: 94px; height: 24px" src="@/assets/icons/adobe.png" />
                        <img style="width: 94px; height: 24px" src="@/assets/icons/abn.png" />
                        <img style="width: 41px; height: 24px" src="@/assets/icons/dla.png" />
                    </div>
                </div>
                <div class="center" id="iframe">
                  <QRcode v-if="!this.$store.state.loggedIn"/>
                </div>        
            </div>
        </div>
        <div id="footer">
                <div class="center, footer">
                    <div class="footer-content">
                        <div>
                            <div class="title-footer">Our certificates</div>
                            <div class="text-footer">EU trusted list: Accepted by all courts & public authorities in the EU.</div>
                        </div>
                        <div>
                            <div>
                                <img style="width: 48px; height: 48px" src="@/assets/icons/secure.png" />
                                <div class="text-footer">Qualified and notified to EU</div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex; text-align: left;">
                            <div class="title-footer">ZealiD AB</div>
                            <div class="text-footer">Reg nr. 556972-4288<br/>Box 3437<br/>10368 Stockholm<br/>Norrlandsgatan 10, 1tr<br/>(Cecil)</div>
                        </div>
                        <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex; text-align: left;">
                            <div class="title-footer">Visit us</div>
                            <a class="text-footer" href="https://www.zealid.com">www.zealid.com</a>
                            <a class="text-footer" href="https://youtube.com/@zealid640">youtube.com/@zealid640</a>
                        </div>
                    </div>
                </div>
        </div>
    </div>
  </div>
</template>

<script>
import QRcode from "@/components/QRcode";
export default {
  components: {
    QRcode,
  },
};
</script>
